<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface ComboBoxMultiselectOption {
  label: string;
  value: string;
  leadingIconTemplate?: string;
  badgeLabel?: string;
  props?: object;
}

export interface ComboBoxMultiselectProps {
  options?: ComboBoxMultiselectOption[];
  label?: string;
  selectedValues?: string[];
  value?: string;
  placeholder?: string;
  message?: string;
  type?: 'default' | 'error' | 'warning' | 'danger';
  clearButton?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  maxRenderedOptions?: number;
  leadingIconTemplate?: IconConstant | '';
  name?: string;
}

const props = withDefaults(defineProps<ComboBoxMultiselectProps>(), {
  options: () => [],
  label: '',
  selectedValues: () => [],
  value: '',
  placeholder: '',
  message: '',
  type: 'default',
  clearButton: false,
  fullWidth: false,
  disabled: false,
  readOnly: false,
  maxRenderedOptions: 100,
  leadingIconTemplate: '',
  name: '',
});

const emit = defineEmits<{
  (event: 'tpgChange', value: TpgChangeEvent<string[]>): void;
  (event: 'update:selectedValues', value: string[]): void;
}>();

function onChange(event: TpgChangeEvent<string[]>) {
  emit('tpgChange', event);
  emit('update:selectedValues', event.value ?? []);
}
</script>

<template>
  <tpg-combo-box-multiselect v-bind="props" @tpg-change="onChange" />
</template>
